import apiRequest from '@/helpers/apiRequests'
import endpoints from '@/consts/endpoints'
import Cart from '@/models/cart'
import helperStorage from '@/helpers/localStorage'

const state = {
  products: helperStorage.getProductsFromStorage() !== null ? helperStorage.getProductsFromStorage() : [],
  cart: new Cart(helperStorage.getCartFromStorage()),
  order: helperStorage.getOrderFromStorage(),
  error: ''
}

const getters = {
  allProducts: (state) => (state.products),
  cart: (state) => {
    return state.cart
  },
  order: (state) => {
    return state.order
  }
}

const mutations = {
  setProducts: (state, products) => {
    state.products = products
  },
  updateCart: (state, data) => {
    state.cart.addToCart(data)
  },
  removeFromCart: (state, { productId, size }) => {
    state.cart.remove(productId, size)
  },
  setOrder: (state, order) => {
    state.order = order
  }
}

const actions = {
  async getProducts ({ commit }) {
    const response = await apiRequest.get(endpoints.getAllProducts)
    if (response.status === 200) {
      commit('setProducts', response.data.products)
      helperStorage.saveProductsToStorage(response.data.products)
      return response.data.products
    }
    return []
  },
  addToCart ({ commit }, data) {
    commit('updateCart', data)
    helperStorage.saveCartToStorage(state)
  },
  removeFromCart ({ commit }, { productId, size }) {
    commit('removeFromCart', { productId, size })
    helperStorage.saveCartToStorage(state)
  },
  removeCart ({ commit }) {
    helperStorage.removeCartFromStorage()
  },
  async validateOrder ({ commit }, order) {
    delete order.totalPrice
    const response = await apiRequest.post(endpoints.validateCart, order)
    if (response.status === 201) {
      commit('setOrder', response.data.order)
      return response
    } else return response
  },
  async addToWaitingList ({ commit }, data) {
    const response = await apiRequest.post(endpoints.addToWaitingList, {
      product: data.product,
      email: data.email,
      size: data.size
    })
    return response.data
  },
  async finalizeOrder ({ commit }, order) {
    const result = await apiRequest.post(endpoints.realizeOrder, order)
    helperStorage.saveOrderToStorage(order)

    return result
  },

  removeOrder ({ commit }) {
    helperStorage.removeOrderFromStorage()
  },

  async calculateDiscount ({ commit }, name) {
    const result = await apiRequest.get(`${endpoints.calculateDiscount}/${name}`)

    return result
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
